import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MapaGoogle from '../mapa/mapaGoogle';
import { Marker } from 'react-google-maps';
import ImgFaseBlue from '../image/traffic-blue.png';
import ImgFaseGrey from '../image/traffic-grey.png';
import ImgPedestrianBlue from '../image/pedestrian-blue.png';
import ImgPedestrianGrey from '../image/pedestrian-grey.png';

import { update } from './faseActions';

const COR_SETA = '#555';
const COR_SETA_MARKER_AZUL = '#1976d2';
const COR_SETA_MARKER_CINZA = '#9e9e9e';
const LABELS_SETAS = ['Origem', 'Destino 1', 'Destino 2', 'Destino 3'];

class MapaFase extends Component {
  constructor(props) {
    super(props);

    this.handleMarkerMouseUp = this.handleMarkerMouseUp.bind(this);
    this.handleMarkerPedestreMouseUp = this.handleMarkerPedestreMouseUp.bind(this);
    this.renderMarker = this.renderMarker.bind(this);
    this.handleSetaAnguloChange = this.handleSetaAnguloChange.bind(this);
    this.adicionarSeta = this.adicionarSeta.bind(this);
    this.removerSeta = this.removerSeta.bind(this);
    this.propagarSetas = this.propagarSetas.bind(this);
    this.girarTodasSetas = this.girarTodasSetas.bind(this);

    const fases = props['data-fases'] || [];
    const idx = props['data-idx'];
    const faseAtual = (idx !== undefined && fases[idx]) || {};
    const tipofase = faseAtual.tipo != null ? parseInt(faseAtual.tipo) : 1;
    const isPedestre = tipofase !== 1;

    // Migração automática: converter array simples para array de arrays
    let setas = [];
    try {
      if (faseAtual.setas) {
        setas = typeof faseAtual.setas === 'string' ? JSON.parse(faseAtual.setas) : faseAtual.setas;
      }
    } catch (_) {}
    if (!Array.isArray(setas)) setas = [];

    // Detectar se é formato antigo (array simples) ou novo (array de arrays)
    const isOldFormat = setas.length > 0 && !Array.isArray(setas[0]);
    if (isOldFormat) {
      // Converter formato antigo [{angulo: 0}] para novo [[{angulo: 0}]]
      setas = [setas];
    }

    // Obter número de posições físicas
    let numPosicoes = 1;
    try {
      if (faseAtual.quantidade_lat_lon) {
        const qtdLatLon =
          typeof faseAtual.quantidade_lat_lon === 'string'
            ? JSON.parse(faseAtual.quantidade_lat_lon)
            : faseAtual.quantidade_lat_lon;
        if (Array.isArray(qtdLatLon) && qtdLatLon.length > 0) {
          numPosicoes = qtdLatLon.length;
        }
      }
    } catch (_) {}

    // Garantir que temos array de setas para cada posição
    while (setas.length < numPosicoes) {
      setas.push([]);
    }

    this.state = {
      fases: fases,
      draggedPositions: {},
      setas: setas,
      isPedestre: isPedestre,
      posicaoAtiva: 0,
      numPosicoes: numPosicoes,
    };

    this.arrowMarkerIconCache = new Map();
  }

  parseSetasFromValue(value, posicaoIdx = null) {
    let parsed = [];
    try {
      if (value) {
        parsed = typeof value === 'string' ? JSON.parse(value) : value;
      }
    } catch (_) {}
    if (!Array.isArray(parsed)) return [];

    // Se é array de arrays (novo formato) e posicaoIdx especificado
    if (posicaoIdx !== null && parsed.length > 0 && Array.isArray(parsed[0])) {
      parsed = parsed[posicaoIdx] || [];
    }
    // Se é array de arrays mas sem posicaoIdx, usar primeira posição
    else if (parsed.length > 0 && Array.isArray(parsed[0])) {
      parsed = parsed[0] || [];
    }

    return parsed.filter(s => s && s.angulo !== undefined && s.angulo !== null);
  }

  // Converte ângulo cartesiano (0°=Leste, 90°=Norte) para rotação SVG (0°=cima)
  cartToSvg(ang) {
    return 90 - ang;
  }

  transformPoints(points, angDeg, cx, cy) {
    const rad = (angDeg * Math.PI) / 180;
    const cos = Math.cos(rad),
      sin = Math.sin(rad);
    return points.map(([x, y]) => [cx + x * cos - y * sin, cy + x * sin + y * cos]);
  }

  pointsToPath(pts) {
    return 'M' + pts.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' L') + ' Z';
  }

  buildArrowMarkerSvg(setas, color, bidirecional) {
    const getAng = s => (s.angulo !== '' && s.angulo != null ? Number(s.angulo) : 0);
    const sa = `stroke="white" stroke-width="3" stroke-linejoin="round" paint-order="stroke"`;
    const cx = 48,
      cy = 48;
    const arrowFullPts = [[-3.5, 22], [-3.5, -12], [-11, -12], [0, -28], [11, -12], [3.5, -12], [3.5, 22]];
    const tailPts = [[-3.5, 30], [-3.5, 0], [3.5, 0], [3.5, 30]];
    const headPts = [[-3.5, 0], [-3.5, -12], [-11, -12], [0, -28], [11, -12], [3.5, -12], [3.5, 0]];

    // Bidirecional (pedestre): todas as setas são pontas completas
    if (bidirecional) {
      let combinedD = '';
      for (let i = 0; i < setas.length; i++) {
        const svgAng = this.cartToSvg(getAng(setas[i]));
        combinedD += (i > 0 ? ' ' : '') + this.pointsToPath(this.transformPoints(arrowFullPts, svgAng, cx, cy));
      }
      return `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" overflow="visible"><path d="${combinedD}" fill="${color}" ${sa} fill-rule="nonzero"/></svg>`;
    }

    const svgAng0 = this.cartToSvg(getAng(setas[0]));

    if (setas.length === 1) {
      const d = this.pointsToPath(this.transformPoints(arrowFullPts, svgAng0, cx, cy));
      return `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" overflow="visible"><path d="${d}" fill="${color}" ${sa}/></svg>`;
    }

    const tailSvgAng = svgAng0 + 180;
    let combinedD = this.pointsToPath(this.transformPoints(tailPts, tailSvgAng, cx, cy));

    const destinos = setas.slice(1);
    for (let i = 0; i < destinos.length; i++) {
      const destSvgAng = this.cartToSvg(getAng(destinos[i]));
      combinedD += ' ' + this.pointsToPath(this.transformPoints(headPts, destSvgAng, cx, cy));
    }

    return `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" overflow="visible"><path d="${combinedD}" fill="${color}" ${sa} fill-rule="nonzero"/></svg>`;
  }

  getArrowMarkerIcon(setasValue, isCurrent, bidirecional) {
    const setas = this.parseSetasFromValue(setasValue);
    if (!setas.length) return null;

    const color = isCurrent ? COR_SETA_MARKER_AZUL : COR_SETA_MARKER_CINZA;
    const key = `${color}|${bidirecional ? 'bi' : 'dir'}|${JSON.stringify(setas)}`;
    const cached = this.arrowMarkerIconCache.get(key);
    if (cached) return cached;

    const svg = this.buildArrowMarkerSvg(setas, color, bidirecional);
    const url = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;

    let icon = { url };
    if (typeof window !== 'undefined' && window.google && window.google.maps) {
      icon = {
        url,
        scaledSize: new window.google.maps.Size(64, 64),
        anchor: new window.google.maps.Point(32, 32),
      };
    }

    this.arrowMarkerIconCache.set(key, icon);
    return icon;
  }

  propagarSetas(novasSetas) {
    const idx = this.props['data-idx'];
    if (idx !== undefined) {
      const fases = [...this.state.fases];
      fases[idx] = { ...fases[idx], setas: JSON.stringify(novasSetas) };
      this.setState({ fases, setas: novasSetas }, () => {
        if (this.props.onFasesChange) this.props.onFasesChange(fases);
      });
    } else {
      this.setState({ setas: novasSetas });
    }
  }

  girarTodasSetas(delta) {
    const posicaoAtiva = this.state.posicaoAtiva;
    const setas = [...this.state.setas];
    if (!setas[posicaoAtiva] || setas[posicaoAtiva].length === 0) return;

    setas[posicaoAtiva] = setas[posicaoAtiva].map(s => {
      let ang = s.angulo !== '' && s.angulo != null ? Number(s.angulo) : 0;
      ang = (ang + delta + 360) % 360;
      return { ...s, angulo: ang };
    });
    this.propagarSetas(setas);
  }

  handleSetaAnguloChange(index, value) {
    const posicaoAtiva = this.state.posicaoAtiva;
    const setas = [...this.state.setas];
    const setasPosicao = [...(setas[posicaoAtiva] || [])];

    if (value === '') {
      setasPosicao[index] = { ...setasPosicao[index], angulo: '' };
      setas[posicaoAtiva] = setasPosicao;
      this.propagarSetas(setas);
      return;
    }
    let num = parseInt(value, 10);
    if (isNaN(num)) return;
    if (num < 0) num = 0;
    if (num > 359) num = 359;
    setasPosicao[index] = { ...setasPosicao[index], angulo: num };
    setas[posicaoAtiva] = setasPosicao;
    this.propagarSetas(setas);
  }

  adicionarSeta() {
    const posicaoAtiva = this.state.posicaoAtiva;
    const setas = [...this.state.setas];
    const setasPosicao = [...(setas[posicaoAtiva] || [])];

    if (this.state.isPedestre) {
      if (setasPosicao.length > 0) return;
      setas[posicaoAtiva] = [{ angulo: 0 }, { angulo: 180 }];
      this.propagarSetas(setas);
      return;
    }

    if (setasPosicao.length >= 4) return;
    setasPosicao.push({ angulo: 0 });
    setas[posicaoAtiva] = setasPosicao;
    this.propagarSetas(setas);
  }

  removerSeta(index) {
    const posicaoAtiva = this.state.posicaoAtiva;
    const setas = [...this.state.setas];

    if (this.state.isPedestre) {
      setas[posicaoAtiva] = [];
      this.propagarSetas(setas);
      return;
    }

    const setasPosicao = (setas[posicaoAtiva] || []).filter((_, i) => i !== index);
    setas[posicaoAtiva] = setasPosicao;
    this.propagarSetas(setas);
  }

  componentDidMount() {
    // Removido: não força mais setas default para pedestre
  }

  componentDidUpdate(prevProps) {
    if (prevProps['data-fases'] !== this.props['data-fases'] && Array.isArray(this.props['data-fases'])) {
      this.setState({ fases: this.props['data-fases'] });
    }

    // Atualizar numPosicoes se quantidade_lat_lon mudar
    const idx = this.props['data-idx'];
    if (idx !== undefined && this.state.fases[idx]) {
      let numPosicoes = 1;
      try {
        const qtdLatLon = this.state.fases[idx].quantidade_lat_lon;
        if (qtdLatLon) {
          const parsed = typeof qtdLatLon === 'string' ? JSON.parse(qtdLatLon) : qtdLatLon;
          if (Array.isArray(parsed) && parsed.length > 0) {
            numPosicoes = parsed.length;
          }
        }
      } catch (_) {}

      if (numPosicoes !== this.state.numPosicoes) {
        const setas = [...this.state.setas];
        while (setas.length < numPosicoes) {
          setas.push([]);
        }
        this.setState({ numPosicoes, setas });
      }
    }
  }

  handleMarkerMouseUp(marker) {
    const data = this.state.fases;
    const faseId = data[this.props['data-idx']].id;

    data[this.props['data-idx']].latitude = marker.latLng.lat();
    data[this.props['data-idx']].longitude = marker.latLng.lng();

    // Armazena a posição arrastada para evitar que volte ao original
    const draggedPositions = { ...this.state.draggedPositions };
    draggedPositions[faseId] = {
      latitude: marker.latLng.lat(),
      longitude: marker.latLng.lng(),
    };

    this.setState({ fases: data, draggedPositions }, () => {
      if (this.props.onFasesChange) this.props.onFasesChange(data);
    });
  }

  handleMarkerPedestreMouseUp(marker, idx) {
    const data = this.state.fases;
    const faseId = data[this.props['data-idx']].id;

    let pedestreLatLon = JSON.parse(data[this.props['data-idx']].quantidade_lat_lon);
    pedestreLatLon[idx].latitude = marker.latLng.lat();
    pedestreLatLon[idx].longitude = marker.latLng.lng();

    data[this.props['data-idx']].quantidade_lat_lon = JSON.stringify(pedestreLatLon);

    // Armazena a posição arrastada para pedestres
    const draggedPositions = { ...this.state.draggedPositions };
    if (!draggedPositions[`${faseId}_pedestres`]) {
      draggedPositions[`${faseId}_pedestres`] = {};
    }
    draggedPositions[`${faseId}_pedestres`][idx] = {
      latitude: marker.latLng.lat(),
      longitude: marker.latLng.lng(),
    };

    this.setState({ fases: data, draggedPositions }, () => {
      if (this.props.onFasesChange) this.props.onFasesChange(data);
    });
  }

  renderMarker(handleMarkerMouseUp) {
    // const list = this.props.list || [];
    // console.log('list',list1);
    const list = this.state.fases;

    let markers = [];
    let position = { lat: this.props.latitude, lng: this.props.longitude };
    let markerAtual = [];

    for (var key in list) {
      // console.log('list[key]',list[key]);
      let objQuantidadeLatLon = [];
      if (list[key].quantidade_lat_lon != null && list[key].quantidade_lat_lon.length) {
        objQuantidadeLatLon = JSON.parse(list[key].quantidade_lat_lon);
      }

      // Usa posição arrastada se existir, caso contrário usa a posição original
      const draggedPos = this.state.draggedPositions[list[key].id];
      if (draggedPos) {
        position = { lat: draggedPos.latitude, lng: draggedPos.longitude };
      } else if (list[key].latitude != null) {
        position = { lat: list[key].latitude, lng: list[key].longitude };
      }

      if (list[key].id == this.props['data-faseId']) {
        // se for a fase atual
        const isPed = parseInt(list[key].tipo) !== 1;
        // Para a fase atual, usar this.state.setas
        if (objQuantidadeLatLon.length) {
          // se tiver quantidade (múltiplas posições)
          for (const idx in objQuantidadeLatLon) {
            const pedestreKey = `${list[key].id}_pedestres`;
            const draggedPedestrePos =
              this.state.draggedPositions[pedestreKey] && this.state.draggedPositions[pedestreKey][idx];
            const pedestrePosition = draggedPedestrePos
              ? { lat: draggedPedestrePos.latitude, lng: draggedPedestrePos.longitude }
              : {
                  lat: parseFloat(objQuantidadeLatLon[idx].latitude),
                  lng: parseFloat(objQuantidadeLatLon[idx].longitude),
                };

            // Usar setas específicas desta posição
            const setasDaPosicao = JSON.stringify(this.state.setas[idx] || []);
            const pedArrowIcon = this.getArrowMarkerIcon(setasDaPosicao, true, isPed);
            markerAtual.push(
              <Marker
                key={list[key].controlador_id + '_' + list[key].id + '_' + idx}
                position={pedestrePosition}
                draggable={true}
                icon={pedArrowIcon || (isPed ? ImgPedestrianBlue : ImgFaseBlue)}
                onMouseUp={event => {
                  this.handleMarkerPedestreMouseUp(event, idx);
                }}
              />,
            );
          }
        } else {
          // Fase sem quantidade, usar setas da posição 0
          const setasDaPosicao = JSON.stringify(this.state.setas[0] || []);
          const arrowIcon = this.getArrowMarkerIcon(setasDaPosicao, true, isPed);
          markerAtual.push(
            <Marker
              key={list[key].controlador_id + '_' + list[key].id}
              position={position}
              draggable={true}
              icon={arrowIcon || (isPed ? ImgPedestrianBlue : ImgFaseBlue)}
              onDragEnd={this.handleMarkerMouseUp}
            />,
          );
        }
      } else {
        const isPedOther = parseInt(list[key].tipo) !== 1;
        if (objQuantidadeLatLon.length) {
          for (const idx in objQuantidadeLatLon) {
            // Usar setas específicas desta posição para outras fases
            const setasOutraFase = this.parseSetasFromValue(list[key].setas, parseInt(idx));
            const setasOutraFaseStr = JSON.stringify(setasOutraFase);
            const otherArrow = this.getArrowMarkerIcon(setasOutraFaseStr, false, isPedOther);
            markerAtual.push(
              <Marker
                key={list[key].controlador_id + '_' + list[key].id + '_' + idx}
                position={{
                  lat: parseFloat(objQuantidadeLatLon[idx].latitude),
                  lng: parseFloat(objQuantidadeLatLon[idx].longitude),
                }}
                draggable={false}
                icon={otherArrow || (isPedOther ? ImgPedestrianGrey : ImgFaseGrey)}
              />,
            );
          }
        } else {
          // Fase sem quantidade, usar setas da posição 0
          const setasOutraFase = this.parseSetasFromValue(list[key].setas, 0);
          const setasOutraFaseStr = JSON.stringify(setasOutraFase);
          const arrowIcon = this.getArrowMarkerIcon(setasOutraFaseStr, false, isPedOther);
          markers.push(
            <Marker
              key={list[key].controlador_id + '_' + list[key].id}
              position={position}
              draggable={false}
              icon={arrowIcon || (isPedOther ? ImgPedestrianGrey : ImgFaseGrey)}
            />,
          );
        }
      }
    }

    // adiciona o atual por ultimo para ficar em cima
    // if (markerAtual != null) {
    if (markerAtual.length) {
      // console.log('markerAtual', markerAtual);

      markers.push(markerAtual);
    }

    return markers;
  }

  renderArrowSvg() {
    const posicaoAtiva = this.state.posicaoAtiva;
    const setas = (this.state.setas && this.state.setas[posicaoAtiva]) || [];
    const cor = COR_SETA;
    const size = 110;
    const cx = size / 2,
      cy = size / 2;
    const r = 48;

    const compassLabels = (
      <g>
        <text x={cx} y="6" textAnchor="middle" fontSize="9" fill="#bbb" fontWeight="600">
          90°
        </text>
        <text x={size - 3} y={cy + 3} textAnchor="middle" fontSize="9" fill="#bbb" fontWeight="600">
          0°
        </text>
        <text x={cx} y={size - 1} textAnchor="middle" fontSize="9" fill="#bbb" fontWeight="600">
          270°
        </text>
        <text x="7" y={cy + 3} textAnchor="middle" fontSize="9" fill="#bbb" fontWeight="600">
          180°
        </text>
      </g>
    );

    if (setas.length === 0) {
      return (
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          <circle cx={cx} cy={cy} r={r} fill="#f8f9fa" stroke="#e0e0e0" strokeWidth="1.5" />
          {compassLabels}
          <g opacity="0.3">
            <path d="M61.5,83 L61.5,53 L54,53 L65,37 L76,53 L68.5,53 L68.5,83 Z" fill="#bbb" />
          </g>
        </svg>
      );
    }

    const getAng = s => (s.angulo !== '' && s.angulo != null ? Number(s.angulo) : 0);
    const cToSvg = ang => 90 - ang;
    const arrowFullPts = [[-3.5, 22], [-3.5, -12], [-11, -12], [0, -28], [11, -12], [3.5, -12], [3.5, 22]];
    const tailPts = [[-3.5, 30], [-3.5, 0], [3.5, 0], [3.5, 30]];
    const headPts = [[-3.5, 0], [-3.5, -12], [-11, -12], [0, -28], [11, -12], [3.5, -12], [3.5, 0]];

    const tPts = (points, angDeg) => {
      const rad = (angDeg * Math.PI) / 180;
      const c = Math.cos(rad),
        s = Math.sin(rad);
      return points.map(([x, y]) => [cx + x * c - y * s, cy + x * s + y * c]);
    };
    const toPath = pts => 'M' + pts.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' L') + ' Z';

    const svgAng0 = cToSvg(getAng(setas[0]));

    // Pedestre (bidirecional): todas as setas são pontas completas
    if (this.state.isPedestre) {
      let combinedD = '';
      setas.forEach((s, i) => {
        combinedD += (i > 0 ? ' ' : '') + toPath(tPts(arrowFullPts, cToSvg(getAng(s))));
      });
      return (
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          <circle cx={cx} cy={cy} r={r} fill="#f8f9fa" stroke="#e0e0e0" strokeWidth="1.5" />
          {compassLabels}
          <path d={combinedD} fill={cor} fillRule="nonzero" />
        </svg>
      );
    }

    // Se só tem 1 seta, desenha seta completa (cauda + ponta)
    if (setas.length === 1) {
      const d = toPath(tPts(arrowFullPts, svgAng0));
      return (
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          <circle cx={cx} cy={cy} r={r} fill="#f8f9fa" stroke="#e0e0e0" strokeWidth="1.5" />
          {compassLabels}
          <path d={d} fill={cor} />
        </svg>
      );
    }

    // 2+ setas: path único com borda única
    const tailSvgAng = svgAng0 + 180;
    let combinedD = toPath(tPts(tailPts, tailSvgAng));
    setas.slice(1).forEach(s => {
      combinedD += ' ' + toPath(tPts(headPts, cToSvg(getAng(s))));
    });

    return (
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={cx} cy={cy} r={r} fill="#f8f9fa" stroke="#e0e0e0" strokeWidth="1.5" />
        {compassLabels}
        <path d={combinedD} fill={cor} fillRule="nonzero" />
      </svg>
    );
  }

  render() {
    const posicaoAtiva = this.state.posicaoAtiva;
    const setas = (this.state.setas && this.state.setas[posicaoAtiva]) || [];
    const numPosicoes = this.state.numPosicoes;

    return (
      <div>
        <MapaGoogle
          containerElement={<div style={{ height: '55vh', width: '100%' }} />}
          mapElement={<div style={{ height: `100%` }} />}
          defaultCenter={{ lat: this.props['data-latitude'], lng: this.props['data-longitude'] }}
          defaultZoom={18}
        >
          {this.renderMarker()}
        </MapaGoogle>

        <div style={{ padding: '12px 16px', borderTop: '1px solid #ddd', backgroundColor: '#fafafa' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '24px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '120px' }}>
              {this.renderArrowSvg()}
              {setas.length > 0 && (
                <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                  <button
                    type="button"
                    onClick={() => this.girarTodasSetas(5)}
                    style={{
                      background: '#fff',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      padding: '2px 10px',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color: '#555',
                    }}
                    title="Girar todas -5° (anti-horário)"
                  >
                    <i className="fa fa-undo" />
                  </button>
                  <button
                    type="button"
                    onClick={() => this.girarTodasSetas(-5)}
                    style={{
                      background: '#fff',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      padding: '2px 10px',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color: '#555',
                    }}
                    title="Girar todas +5° (horário)"
                  >
                    <i className="fa fa-repeat" />
                  </button>
                </div>
              )}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', flex: 1 }}>
              <>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', flexWrap: 'wrap' }}
                >
                  <span style={{ fontWeight: 'bold', fontSize: '13px' }}>
                    {this.state.isPedestre ? 'Faixa de pedestre' : 'Setas direcionais'}
                  </span>
                  <span style={{ fontSize: '11px', color: '#888' }}>
                    {this.state.isPedestre
                      ? 'Use os botões de girar para ajustar a orientação da faixa.'
                      : '(Origem = sentido da via | Destinos = para onde pode ir | 0°=Leste 90°=Cima 180°=Oeste 270°=Baixo)'}
                  </span>
                </div>

                {numPosicoes > 1 && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    <span style={{ fontSize: '12px', fontWeight: '600', color: '#555' }}>Posição física:</span>
                    {Array.from({ length: numPosicoes }, (_, i) => (
                      <button
                        key={i}
                        type="button"
                        onClick={() => this.setState({ posicaoAtiva: i })}
                        style={{
                          padding: '4px 12px',
                          fontSize: '12px',
                          fontWeight: posicaoAtiva === i ? 'bold' : 'normal',
                          backgroundColor: posicaoAtiva === i ? '#1976d2' : '#fff',
                          color: posicaoAtiva === i ? '#fff' : '#555',
                          border: posicaoAtiva === i ? '1px solid #1565c0' : '1px solid #ccc',
                          borderRadius: '4px',
                          cursor: 'pointer',
                        }}
                      >
                        {i + 1}
                      </button>
                    ))}
                  </div>
                )}

                {!this.state.isPedestre &&
                  setas.map((seta, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#555', minWidth: '72px' }}>
                        {LABELS_SETAS[i]}
                      </span>
                      <input
                        type="number"
                        min="0"
                        max="359"
                        value={seta.angulo}
                        onChange={e => this.handleSetaAnguloChange(i, e.target.value)}
                        placeholder="0-359"
                        style={{
                          width: '75px',
                          padding: '3px 6px',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          fontSize: '13px',
                        }}
                      />
                      <span style={{ fontSize: '12px', color: '#888' }}>°</span>
                      <button
                        type="button"
                        onClick={() => this.removerSeta(i)}
                        style={{
                          background: 'none',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          color: '#e53935',
                          cursor: 'pointer',
                          padding: '2px 8px',
                          fontSize: '12px',
                        }}
                        title="Remover seta"
                      >
                        <i className="fa fa-times" />
                      </button>
                    </div>
                  ))}

                {this.state.isPedestre && setas.length > 0 && (
                  <button
                    type="button"
                    onClick={() => this.removerSeta(0)}
                    style={{
                      background: 'none',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      color: '#e53935',
                      cursor: 'pointer',
                      padding: '4px 12px',
                      fontSize: '12px',
                      alignSelf: 'flex-start',
                    }}
                    title="Remover faixa"
                  >
                    <i className="fa fa-times" /> Remover seta
                  </button>
                )}

                {((this.state.isPedestre && setas.length === 0) || (!this.state.isPedestre && setas.length < 4)) && (
                  <button
                    type="button"
                    onClick={this.adicionarSeta}
                    style={{
                      background: '#fff',
                      border: '1px solid #4CAF50',
                      borderRadius: '4px',
                      color: '#4CAF50',
                      cursor: 'pointer',
                      padding: '4px 12px',
                      fontSize: '12px',
                      alignSelf: 'flex-start',
                      marginTop: '2px',
                    }}
                  >
                    <i className="fa fa-plus" /> Adicionar seta
                  </button>
                )}

                {setas.length === 0 && (
                  <span style={{ fontSize: '12px', color: '#999', fontStyle: 'italic' }}>
                    {this.state.isPedestre
                      ? 'Nenhuma seta configurada. Será exibida a tag padrão de pedestre no mapa.'
                      : 'Nenhuma seta configurada. Clique em "Adicionar seta" para definir direções.'}
                  </span>
                )}
              </>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({ list: state.faseCad.list });
const mapDispatchToProps = dispatch => bindActionCreators({ update }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(MapaFase);
